module.exports = __webpack_public_path__ + "static/img/logo Leader .abbcac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo Leader .png
// module id = U/7u
// module chunks = 1